import React from "react";

import type { ZkEvmL2TxnBatchesItem } from "types/api/zkEvmL2";

import type { StatusTagType } from "./StatusTag";
import StatusTag from "./StatusTag";

export interface Props {
  status: ZkEvmL2TxnBatchesItem["status"];
  isLoading?: boolean;
}

const ZkEvmL2TxnBatchStatus = ({ status, isLoading }: Props) => {
  let type: StatusTagType;

  switch (status) {
    case "L1 Sequence Confirmed":
    case "Finalized":
      type = "ok";
      break;
    default:
      type = "pending";
      break;
  }

  return <StatusTag type={type} text={status} loading={isLoading} />;
};

export default ZkEvmL2TxnBatchStatus;
